import { PromotionType } from "@omni/types/api/product/bff/shared/enums/promotionType.enum";
import { SalesIncentiveType } from "@omni/types/api/product/bff/shared/enums/salesIncentiveType.enum";
import { CloudPromotionType } from "@omni/types/api/product/cloud/shared/enums/promotionType.enum";
import { AlgoliaSearchPromotionType } from "@omni/types/api/search/algolia/product/shared/enums/promotionType.enum";
import { BffSearchPromotionType } from "@omni/types/api/search/bff/product/shared/enums/promotionType.enum";

const fromCloudToBffMap: Record<CloudPromotionType, PromotionType> = {
    [CloudPromotionType.ActiePrijs]: PromotionType.ActiePrijs,
    [CloudPromotionType.CombinatiePrijs]: PromotionType.CombinatiePrijs,
    [CloudPromotionType.ExtraBonuspunten]: PromotionType.ExtraBonuspunten,
    [CloudPromotionType.GratisArtikel]: PromotionType.GratisArtikel,
    [CloudPromotionType.KortingBedrag]: PromotionType.KortingBedrag,
    [CloudPromotionType.KortingProcent]: PromotionType.KortingProcent,
    [CloudPromotionType.DocumentKorting]: PromotionType.DocumentKorting,
    [CloudPromotionType.KortingProcentUitz]: PromotionType.KortingProcentUitz,
    [CloudPromotionType.FolderPrijs]: PromotionType.FolderPrijs,
    [CloudPromotionType.OutletPrijs]: PromotionType.OutletPrijs,
    [CloudPromotionType.Cashback]: PromotionType.Cashback,
    [CloudPromotionType.GratisTransportkost]: PromotionType.GratisTransportkost,
    [CloudPromotionType.Nieuw]: PromotionType.Nieuw
};

const fromBffToCloudMap: Record<PromotionType, CloudPromotionType> = {
    [PromotionType.ActiePrijs]: CloudPromotionType.ActiePrijs,
    [PromotionType.CombinatiePrijs]: CloudPromotionType.CombinatiePrijs,
    [PromotionType.ExtraBonuspunten]: CloudPromotionType.ExtraBonuspunten,
    [PromotionType.GratisArtikel]: CloudPromotionType.GratisArtikel,
    [PromotionType.KortingBedrag]: CloudPromotionType.KortingBedrag,
    [PromotionType.KortingProcent]: CloudPromotionType.KortingProcent,
    [PromotionType.DocumentKorting]: CloudPromotionType.DocumentKorting,
    [PromotionType.KortingProcentUitz]: CloudPromotionType.KortingProcentUitz,
    [PromotionType.FolderPrijs]: CloudPromotionType.FolderPrijs,
    [PromotionType.OutletPrijs]: CloudPromotionType.OutletPrijs,
    [PromotionType.Cashback]: CloudPromotionType.Cashback,
    [PromotionType.GratisTransportkost]: CloudPromotionType.GratisTransportkost,
    [PromotionType.Nieuw]: CloudPromotionType.Nieuw
};

const fromAlgoliaSearchToBffMap: Record<
    AlgoliaSearchPromotionType,
    PromotionType
> = {
    [AlgoliaSearchPromotionType.ActiePrijs]: PromotionType.ActiePrijs,
    [AlgoliaSearchPromotionType.CombinatiePrijs]: PromotionType.CombinatiePrijs,
    [AlgoliaSearchPromotionType.ExtraBonuspunten]:
        PromotionType.ExtraBonuspunten,
    [AlgoliaSearchPromotionType.GratisArtikel]: PromotionType.GratisArtikel,
    [AlgoliaSearchPromotionType.KortingBedrag]: PromotionType.KortingBedrag,
    [AlgoliaSearchPromotionType.KortingProcent]: PromotionType.KortingProcent,
    [AlgoliaSearchPromotionType.DocumentKorting]: PromotionType.DocumentKorting,
    [AlgoliaSearchPromotionType.KortingProcentUitz]:
        PromotionType.KortingProcentUitz,
    [AlgoliaSearchPromotionType.FolderPrijs]: PromotionType.FolderPrijs,
    [AlgoliaSearchPromotionType.OutletPrijs]: PromotionType.OutletPrijs,
    [AlgoliaSearchPromotionType.Cashback]: PromotionType.Cashback,
    [AlgoliaSearchPromotionType.GratisTransportkost]:
        PromotionType.GratisTransportkost,
    [AlgoliaSearchPromotionType.Nieuw]: PromotionType.Nieuw
};

const fromAlgoliaSearchToBffSearchMap: Record<
    AlgoliaSearchPromotionType,
    BffSearchPromotionType
> = {
    [AlgoliaSearchPromotionType.ActiePrijs]: BffSearchPromotionType.ActiePrijs,
    [AlgoliaSearchPromotionType.CombinatiePrijs]:
        BffSearchPromotionType.CombinatiePrijs,
    [AlgoliaSearchPromotionType.ExtraBonuspunten]:
        BffSearchPromotionType.ExtraBonuspunten,
    [AlgoliaSearchPromotionType.GratisArtikel]:
        BffSearchPromotionType.GratisArtikel,
    [AlgoliaSearchPromotionType.KortingBedrag]:
        BffSearchPromotionType.KortingBedrag,
    [AlgoliaSearchPromotionType.KortingProcent]:
        BffSearchPromotionType.KortingProcent,
    [AlgoliaSearchPromotionType.DocumentKorting]:
        BffSearchPromotionType.DocumentKorting,
    [AlgoliaSearchPromotionType.KortingProcentUitz]:
        BffSearchPromotionType.KortingProcentUitz,
    [AlgoliaSearchPromotionType.FolderPrijs]:
        BffSearchPromotionType.FolderPrijs,
    [AlgoliaSearchPromotionType.OutletPrijs]:
        BffSearchPromotionType.OutletPrijs,
    [AlgoliaSearchPromotionType.Cashback]: BffSearchPromotionType.Cashback,
    [AlgoliaSearchPromotionType.GratisTransportkost]:
        BffSearchPromotionType.GratisTransportkost,
    [AlgoliaSearchPromotionType.Nieuw]: BffSearchPromotionType.Nieuw
};

const fromBffToAlgoliaSearchMap: Record<
    PromotionType,
    AlgoliaSearchPromotionType
> = {
    [PromotionType.ActiePrijs]: AlgoliaSearchPromotionType.ActiePrijs,
    [PromotionType.CombinatiePrijs]: AlgoliaSearchPromotionType.CombinatiePrijs,
    [PromotionType.ExtraBonuspunten]:
        AlgoliaSearchPromotionType.ExtraBonuspunten,
    [PromotionType.GratisArtikel]: AlgoliaSearchPromotionType.GratisArtikel,
    [PromotionType.KortingBedrag]: AlgoliaSearchPromotionType.KortingBedrag,
    [PromotionType.KortingProcent]: AlgoliaSearchPromotionType.KortingProcent,
    [PromotionType.DocumentKorting]: AlgoliaSearchPromotionType.DocumentKorting,
    [PromotionType.KortingProcentUitz]:
        AlgoliaSearchPromotionType.KortingProcentUitz,
    [PromotionType.FolderPrijs]: AlgoliaSearchPromotionType.FolderPrijs,
    [PromotionType.OutletPrijs]: AlgoliaSearchPromotionType.OutletPrijs,
    [PromotionType.Cashback]: AlgoliaSearchPromotionType.Cashback,
    [PromotionType.GratisTransportkost]:
        AlgoliaSearchPromotionType.GratisTransportkost,
    [PromotionType.Nieuw]: AlgoliaSearchPromotionType.Nieuw
};

const fromCloudToAlgoliaSearchMap: Record<
    CloudPromotionType,
    AlgoliaSearchPromotionType
> = {
    [CloudPromotionType.ActiePrijs]: AlgoliaSearchPromotionType.ActiePrijs,
    [CloudPromotionType.CombinatiePrijs]:
        AlgoliaSearchPromotionType.CombinatiePrijs,
    [CloudPromotionType.ExtraBonuspunten]:
        AlgoliaSearchPromotionType.ExtraBonuspunten,
    [CloudPromotionType.GratisArtikel]:
        AlgoliaSearchPromotionType.GratisArtikel,
    [CloudPromotionType.KortingBedrag]:
        AlgoliaSearchPromotionType.KortingBedrag,
    [CloudPromotionType.KortingProcent]:
        AlgoliaSearchPromotionType.KortingProcent,
    [CloudPromotionType.DocumentKorting]:
        AlgoliaSearchPromotionType.DocumentKorting,
    [CloudPromotionType.KortingProcentUitz]:
        AlgoliaSearchPromotionType.KortingProcentUitz,
    [CloudPromotionType.FolderPrijs]: AlgoliaSearchPromotionType.FolderPrijs,
    [CloudPromotionType.OutletPrijs]: AlgoliaSearchPromotionType.OutletPrijs,
    [CloudPromotionType.Cashback]: AlgoliaSearchPromotionType.Cashback,
    [CloudPromotionType.GratisTransportkost]:
        AlgoliaSearchPromotionType.GratisTransportkost,
    [CloudPromotionType.Nieuw]: AlgoliaSearchPromotionType.Nieuw
};

const fromBffSearchToBffMap: Record<BffSearchPromotionType, PromotionType> = {
    [BffSearchPromotionType.ActiePrijs]: PromotionType.ActiePrijs,
    [BffSearchPromotionType.CombinatiePrijs]: PromotionType.CombinatiePrijs,
    [BffSearchPromotionType.ExtraBonuspunten]: PromotionType.ExtraBonuspunten,
    [BffSearchPromotionType.GratisArtikel]: PromotionType.GratisArtikel,
    [BffSearchPromotionType.KortingBedrag]: PromotionType.KortingBedrag,
    [BffSearchPromotionType.KortingProcent]: PromotionType.KortingProcent,
    [BffSearchPromotionType.DocumentKorting]: PromotionType.DocumentKorting,
    [BffSearchPromotionType.KortingProcentUitz]:
        PromotionType.KortingProcentUitz,
    [BffSearchPromotionType.FolderPrijs]: PromotionType.FolderPrijs,
    [BffSearchPromotionType.OutletPrijs]: PromotionType.OutletPrijs,
    [BffSearchPromotionType.Cashback]: PromotionType.Cashback,
    [BffSearchPromotionType.GratisTransportkost]:
        PromotionType.GratisTransportkost,
    [BffSearchPromotionType.Nieuw]: PromotionType.Nieuw
};

const fromBffSearchToAlgoliaSearchMap: Record<
    BffSearchPromotionType,
    AlgoliaSearchPromotionType
> = {
    [BffSearchPromotionType.ActiePrijs]: AlgoliaSearchPromotionType.ActiePrijs,
    [BffSearchPromotionType.CombinatiePrijs]:
        AlgoliaSearchPromotionType.CombinatiePrijs,
    [BffSearchPromotionType.ExtraBonuspunten]:
        AlgoliaSearchPromotionType.ExtraBonuspunten,
    [BffSearchPromotionType.GratisArtikel]:
        AlgoliaSearchPromotionType.GratisArtikel,
    [BffSearchPromotionType.KortingBedrag]:
        AlgoliaSearchPromotionType.KortingBedrag,
    [BffSearchPromotionType.KortingProcent]:
        AlgoliaSearchPromotionType.KortingProcent,
    [BffSearchPromotionType.DocumentKorting]:
        AlgoliaSearchPromotionType.DocumentKorting,
    [BffSearchPromotionType.KortingProcentUitz]:
        AlgoliaSearchPromotionType.KortingProcentUitz,
    [BffSearchPromotionType.FolderPrijs]:
        AlgoliaSearchPromotionType.FolderPrijs,
    [BffSearchPromotionType.OutletPrijs]:
        AlgoliaSearchPromotionType.OutletPrijs,
    [BffSearchPromotionType.Cashback]: AlgoliaSearchPromotionType.Cashback,
    [BffSearchPromotionType.GratisTransportkost]:
        AlgoliaSearchPromotionType.GratisTransportkost,
    [BffSearchPromotionType.Nieuw]: AlgoliaSearchPromotionType.Nieuw
};

const fromBffToBffSearchMap: Record<PromotionType, BffSearchPromotionType> = {
    [PromotionType.ActiePrijs]: BffSearchPromotionType.ActiePrijs,
    [PromotionType.CombinatiePrijs]: BffSearchPromotionType.CombinatiePrijs,
    [PromotionType.ExtraBonuspunten]: BffSearchPromotionType.ExtraBonuspunten,
    [PromotionType.GratisArtikel]: BffSearchPromotionType.GratisArtikel,
    [PromotionType.KortingBedrag]: BffSearchPromotionType.KortingBedrag,
    [PromotionType.KortingProcent]: BffSearchPromotionType.KortingProcent,
    [PromotionType.DocumentKorting]: BffSearchPromotionType.DocumentKorting,
    [PromotionType.KortingProcentUitz]:
        BffSearchPromotionType.KortingProcentUitz,
    [PromotionType.FolderPrijs]: BffSearchPromotionType.FolderPrijs,
    [PromotionType.OutletPrijs]: BffSearchPromotionType.OutletPrijs,
    [PromotionType.Cashback]: BffSearchPromotionType.Cashback,
    [PromotionType.GratisTransportkost]:
        BffSearchPromotionType.GratisTransportkost,
    [PromotionType.Nieuw]: BffSearchPromotionType.Nieuw
};

const fromCloudToBffSearchMap: Record<
    CloudPromotionType,
    BffSearchPromotionType
> = {
    [CloudPromotionType.ActiePrijs]: BffSearchPromotionType.ActiePrijs,
    [CloudPromotionType.CombinatiePrijs]:
        BffSearchPromotionType.CombinatiePrijs,
    [CloudPromotionType.ExtraBonuspunten]:
        BffSearchPromotionType.ExtraBonuspunten,
    [CloudPromotionType.GratisArtikel]: BffSearchPromotionType.GratisArtikel,
    [CloudPromotionType.KortingBedrag]: BffSearchPromotionType.KortingBedrag,
    [CloudPromotionType.KortingProcent]: BffSearchPromotionType.KortingProcent,
    [CloudPromotionType.DocumentKorting]:
        BffSearchPromotionType.DocumentKorting,
    [CloudPromotionType.KortingProcentUitz]:
        BffSearchPromotionType.KortingProcentUitz,
    [CloudPromotionType.FolderPrijs]: BffSearchPromotionType.FolderPrijs,
    [CloudPromotionType.OutletPrijs]: BffSearchPromotionType.OutletPrijs,
    [CloudPromotionType.Cashback]: BffSearchPromotionType.Cashback,
    [CloudPromotionType.GratisTransportkost]:
        BffSearchPromotionType.GratisTransportkost,
    [CloudPromotionType.Nieuw]: BffSearchPromotionType.Nieuw
};

const fromSalesIncentiveTypeToBffMap: Record<
    SalesIncentiveType,
    PromotionType | undefined
> = {
    [SalesIncentiveType.ActiePrijs]: PromotionType.ActiePrijs,
    [SalesIncentiveType.CombinatiePrijs]: PromotionType.CombinatiePrijs,
    [SalesIncentiveType.ExtraBonusPunten]: PromotionType.ExtraBonuspunten,
    [SalesIncentiveType.GratisArtikel]: PromotionType.GratisArtikel,
    [SalesIncentiveType.KortingProcent]: PromotionType.KortingProcent,
    [SalesIncentiveType.FolderPrijs]: PromotionType.FolderPrijs,
    [SalesIncentiveType.OutletPrijs]: PromotionType.OutletPrijs,
    [SalesIncentiveType.Cashback]: PromotionType.Cashback,
    [SalesIncentiveType.GratisTransport]: PromotionType.GratisTransportkost,
    [SalesIncentiveType.EveryDayLowPrice]: undefined
};

export const PromotionTypeMapper = {
    fromCloudToBff: (promotionType: CloudPromotionType) =>
        fromCloudToBffMap[promotionType],
    fromCloudToAlgoliaSearch: (promotionType: CloudPromotionType) =>
        fromCloudToAlgoliaSearchMap[promotionType],
    fromCloudToBffSearch: (promotionType: CloudPromotionType) =>
        fromCloudToBffSearchMap[promotionType],
    fromBffToCloud: (promotionType: PromotionType) =>
        fromBffToCloudMap[promotionType],
    fromBffToAlgoliaSearch: (promotionType: PromotionType) =>
        fromBffToAlgoliaSearchMap[promotionType],
    fromBffToBffSearch: (promotionType: PromotionType) =>
        fromBffToBffSearchMap[promotionType],
    fromAlgoliaSearchToBff: (promotionType: AlgoliaSearchPromotionType) =>
        fromAlgoliaSearchToBffMap[promotionType],
    fromAlgoliaSearchToBffSearch: (promotionType: AlgoliaSearchPromotionType) =>
        fromAlgoliaSearchToBffSearchMap[promotionType],
    fromBffSearchToBff: (promotionType: BffSearchPromotionType) =>
        fromBffSearchToBffMap[promotionType],
    fromBffSearchToAlgoliaSearch: (promotionType: BffSearchPromotionType) =>
        fromBffSearchToAlgoliaSearchMap[promotionType],
    fromSalesIncentiveType: (salesIncentiveType: SalesIncentiveType) =>
        fromSalesIncentiveTypeToBffMap[salesIncentiveType]
};
